<template>
  <el-dialog
    class="talent-matrix-cell-edit"
    title="Редактирование ячейки"
    :visible.sync="show"
    top="2vh"
    :close-on-click-modal="false"
  >
    <el-form
      size="small"
      ref="editForm"
      label-position="top"
      :model="cell"
      :rules="cellRules"
      @submit.native.prevent="saveCell"
    >
      <el-form-item label="Название" prop="name">
        <el-input
          maxlength="1000"
          v-model="cell.name"
          ref="cellToFocus"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="Описание" prop="description">
        <el-input
          maxlength="10000"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 6}"
          v-model="cell.description"
        ></el-input>
      </el-form-item>
      <el-form-item label="Цвет" prop="color">
        <el-color-picker
          v-model="cell.color"
        ></el-color-picker>
      </el-form-item>
      <el-form-item label="Диапазон значения Потенциала (ось Y)">
        <div>
          <span>От</span>
          <el-input
            style="width: 100px; margin: 0 10px"
            :maxlength="6"
            v-model="cell.potential_range_start"
            v-number-format="{decimals: 2, space:true}"
          ></el-input>
          <span>До</span>
          <el-input
            style="width: 100px; margin: 0 10px"
            :maxlength="6"
            v-model="cell.potential_range_end"
            v-number-format="{decimals: 2, space:true}"
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="Диапазон значения Производительности (ось X)">
        <div>
          <span>От</span>
          <el-input
            style="width: 100px; margin: 0 10px"
            :maxlength="6"
            v-model="cell.productivity_range_start"
            v-number-format="{decimals: 2, space:true}"
          ></el-input>
          <span>До</span>
          <el-input
            style="width: 100px; margin: 0 10px"
            :maxlength="6"
            v-model="cell.productivity_range_end"
            v-number-format="{decimals: 2, space:true}"
          ></el-input>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">Отмена</el-button>
      <el-button
        type="primary"
        size="small"
        :loading="loading"
        @click="saveCell"
      > Сохранить
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "talent-matrix-cell-edit-dialog",
  data() {
    return {
      show: false,
      loading: false,
      cell: {
        id: null,
        name: null,
        description: '',
        color: null,
        potential_range_start: null,
        potential_range_end: null,
        productivity_range_start: null,
        productivity_range_end: null,
      },
      cellRules: {
        name: [{required: true, message: 'Поле обязательно для заполнения', trigger: 'blur'}],
      },
    }
  },
  methods: {
    async open(cell) {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }

      this.cell = Object.assign({}, cell);
      this.show = true;
      this.$nextTick(() => this.$refs.cellToFocus.focus());
    },
    close() {
      this.show = false;
    },
    saveCell() {
      this.$refs.editForm.validate().then(()=> {
        this.loading = true;
        this.$api.talentMatrix.matrixCellUpdate({
          id: this.cell.id,
          name: this.cell.name,
          description: this.cell.description,
          color: this.cell.color,
          potential_range_start: this.cell.potential_range_start,
          potential_range_end: this.cell.potential_range_end,
          productivity_range_start: this.cell.productivity_range_start,
          productivity_range_end: this.cell.productivity_range_end,
        })
          .then(data => {
            this.$notify.success({
              title: 'Обновлено',
              message: 'Ячейка успешно обновлена'
            });
          })
          .finally(()=>{
            this.loading = false;
            this.close();
            this.$emit('cell-update');
          })
      })
    },
  }
}
</script>

<style scoped>
  .talent-matrix-cell-edit {
    .el-color-picker--small .el-color-picker__trigger {
      width: 200px !important;
    }
  }
</style>